import script from "./ModalLicencaAcabou.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalLicencaAcabou.vue?vue&type=script&setup=true&lang=js"

import "./ModalLicencaAcabou.vue?vue&type=style&index=0&id=ce9e60f0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce9e60f0"]])

export default __exports__